(function(Drupal, $, once){
    Drupal.behaviors.mo8 = {
        attach() {
            $(once('mo8', '.MO8')).each(function(){
                const $component = $(this);
                const $link = $component.find('.MO8__content__cta a');
                const link_url = $link.attr("href");
                const link_target = $link.attr("target");

                // Make whole component clickable.
                $component.click(function(e) {
                    if (link_target) {
                        window.open(link_url, link_target);
                    } else if (link_url) {
                        window.open(link_url);
                    }
                });
                // Prevent propagation on link click.
                $component.find('a').click(function(event){
                    event.stopPropagation();
                });
            });
        }
    };
})(Drupal, jQuery, once);
